import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Employee, EmployeePositionId } from '../../../classes/models/employee/Employee';
import { EmployeeDetails } from '../../../classes/models/employee/EmployeeDetails';
import { EmployeeAdapter } from '../../../classes/adapters/response/employee/EmployeeAdapter';
import { EmployeeDetailsAdapter } from '../../../classes/adapters/response/employee/EmployeeDetailsAdapter';
import { EmployeeResponse, EmployeeSummaryResponse, } from '../../../interfaces/response/EmployeeResponse';

/**
 * This service communicates with backend to retrieve employee data.
 */
@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  private http = inject(HttpClient);
  private employeeAdapter = inject(EmployeeAdapter);
  private employeeDetailsAdapter = inject(EmployeeDetailsAdapter);

  url = environment.apiUrl + '/employees';

  /**
   * Retrieves a list of summarized employee information for a specific store.
   * @param storeId an identifier of a store.
   */
  get(storeId: string): Observable<Employee[]> {
    return this.http.get(this.url, { params: { storeSlug: storeId } }).pipe(
      map((data: EmployeeSummaryResponse[]) => data.map(item => this.employeeAdapter.adapt(item))));
  }

  /**
   * Retrieves the full data of one specific employee.
   * @param id identifiers of employee and position.
   */
  getDetails(id: EmployeePositionId): Observable<EmployeeDetails> {
    const url = `${this.url}/${id.parseEmployeeId()}/positions/${id.parsePositionId()}`;
    return this.http.get(url).pipe(
      map((item: EmployeeResponse) => this.employeeDetailsAdapter.adapt(item)));
  }
}
